import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Region } from 'src/app/models/Port';
import { VoyageService } from '../../services/voyage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { PortService } from 'src/app/core-services/port.service';
import { DefaultRegion } from 'src/app/Enum/Enum';

@Component({
  selector: 'app-voyage-performance-level4',
  templateUrl: './voyage-performance-level4.component.html',
  styleUrls: ['./voyage-performance-level4.component.scss']
})
export class VoyagePerformanceLevel4Component implements OnInit {

  voyageform: FormGroup;
  fromRegionId: number;
  toRegionId: number;
  dataSource: Object;
  regionsData: Region[] = [];
  currentDate: Date;
  currentYear: number;
  yearsDataList: any[] = [];
  submitted: boolean = false;
  mothData: any[] = [];
  searchDate: string = '';
  isFirstTime: boolean = true;
  noOfVessels: any;
  frequencyData: any;
  noOfPortCalls: any;
  voyageLength: any;
  companyName: string[] = [];
  companydata: number[] = [];
  shippingLineId: number[] = [];
  options: any;

  constructor(private fb: FormBuilder, private voyageService: VoyageService, private spinner: NgxSpinnerService, private router: Router, private portService: PortService) { }

  ngOnInit() {

    this.voyageform = this.fb.group({
      fromRegion: ["", Validators.required],
      toRegioin: ["", Validators.required],
      month: [""],
      year: ["", Validators.required]
    });

    this.currentDate = new Date();
    this.currentYear = this.currentDate.getUTCFullYear();
    for (let year = this.currentYear; year <= this.currentYear + 50; year++) {
      if (year != null) {
        var yearData =
        {
          value: year,
          viewValue: year,
        };
        this.yearsDataList.push(yearData);
      }
    }
    this.getMonthLookUpData();
    this.getRegionData();

    this.fromRegionId = DefaultRegion.NorthernAfrica;
    this.toRegionId = DefaultRegion.EasternAfrica;
    this.searchDate = this.currentDate.getUTCFullYear().toString();
    var defaultYear = {
      value: this.currentYear,
      viewValue: this.currentYear
    }
    this.voyageform.controls.year.setValue(defaultYear);
    this.getVoyagePerformance();
  }

  getMonthLookUpData() {
    this.voyageService.getMasterLookUpMonth().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.mothData = response.content;
      }
    });
  }

  getRegionData() {
    this.voyageService.getRegionData().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.regionsData = response.content;
        if (this.isFirstTime == true) {
          var fromRegion = response.content.filter(x => x.id == DefaultRegion.NorthernAfrica);
          var toRegion = response.content.filter(x => x.id == DefaultRegion.EasternAfrica);
          if (fromRegion != null && fromRegion.length > 0) {
            this.fromRegionId = fromRegion[0].id;
            // this.voyageform.controls.fromRegion.setValue(this.fromRegionId);
          }
          if (toRegion != null && toRegion.length > 0) {
            this.toRegionId = toRegion[0].id;
            // this.voyageform.controls.toRegion.setValue(toRegion[0]);
          }
          // this.isFirstTime = false;          
        }
      }
    });
  }

  getVoyagePerformance() {
    if (this.fromRegionId > 0 && this.toRegionId > 0 && this.searchDate != null && this.searchDate != '') {
      var voyageData = {
        fromPortId: this.fromRegionId,
        toPortId: this.toRegionId,
        searchDate: this.searchDate
      }
      this.spinner.show();
      this.voyageService.getVoyagePerformanceByRegion(voyageData).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.spinner.hide();
          // bind No of Vessels chart
          if (response.content.noOfVesselsWithShips != null && response.content.noOfVesselsWithShips.length > 0) {
            let res = response.content;
            this.noOfVessels = [];
            this.companyName = [];
            this.companydata = [];
            this.shippingLineId = [];
            response.content.noOfVesselsWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {
                if (element.companyName == 'Wallenius Wilhelmsen Ocean') {
                  element.companyName = 'WWO'
                }
                this.companyName.push(element.companyName);
                this.companydata.push(element.noOfVessels);
                this.shippingLineId.push(element.id);
              }
            });

            this.noOfVessels = {
              labels: this.companyName,
              datasets: [
                {
                  lablesfortip: this.companyName,
                  shipId: this.shippingLineId,
                  label: 'No Of Vessels',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          // bind Frequency of shippiingline
          if (response.content.frequencyOfWithShips != null && response.content.frequencyOfWithShips.length > 0) {
            let res = response.content.frequencyOfWithShips;
            this.frequencyData = [];
            this.companyName = [];
            this.companydata = [];
            this.shippingLineId = [];
            response.content.frequencyOfWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {
                if (element.companyName == 'Wallenius Wilhelmsen Ocean') {
                  element.companyName = 'WWO'
                }
                this.companyName.push(element.companyName);
                this.companydata.push(element.noOfAVGDays);
                this.shippingLineId.push(element.id);
              }
            });

            this.frequencyData = {
              labels: this.companyName,
              datasets: [
                {
                  lablesfortip: this.companyName,
                  shipId: this.shippingLineId,
                  label: 'Frequency(days betwen sailings)',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          // bind No Of port call
          if (response.content.noOfPortCallsWithShips != null && response.content.noOfPortCallsWithShips.length > 0) {
            let res = response.content.noOfPortCallsWithShips;
            this.noOfPortCalls = [];
            this.companyName = [];
            this.companydata = [];
            this.shippingLineId = [];
            response.content.noOfPortCallsWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {
                if (element.companyName == 'Wallenius Wilhelmsen Ocean') {
                  element.companyName = 'WWO'
                }
                this.companyName.push(element.companyName);
                this.companydata.push(element.noOfPortCall);
                this.shippingLineId.push(element.id);
              }
            });

            this.noOfPortCalls = {
              labels: this.companyName,
              datasets: [
                {
                  lablesfortip: this.companyName,
                  shipId: this.shippingLineId,
                  label: 'No of ports call in voyage',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          // Bind Voyage Length
          if (response.content.voyageLengthWithShips != null && response.content.voyageLengthWithShips.length > 0) {
            let res = response.content.voyageLengthWithShips;
            this.voyageLength = [];
            this.companyName = [];
            this.companydata = [];
            this.shippingLineId = [];
            response.content.voyageLengthWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {
                if (element.companyName == 'Wallenius Wilhelmsen Ocean') {
                  element.companyName = 'WWO'
                }
                this.companyName.push(element.companyName);
                this.companydata.push(element.noOfAVGDays);
                this.shippingLineId.push(element.id);
              }
            });

            this.voyageLength = {
              labels: this.companyName,
              datasets: [
                {
                  lablesfortip: this.companyName,
                  shipId: this.shippingLineId,
                  label: 'Voyage length in days',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          this.options = {
            title: {
              display: true,
              //text: 'My Title',
              fontSize: 16
            },
            legend: {
              position: 'bottom'
            }
          };
        }
        this.spinner.hide();
      });
    }
  }
  selectDataOfChart(event) {

  }
  onSearch() {

  }

}
